export const INITIAL_STATE = {
	isValid: {
		type: true,
		external_id: true,
		position: true,
		profession_id: true,
		division_id: true
	},
	values: {
		type: null,
		external_id: '',
		position: '',
		profession_id: null,
		division_id: null,
		sout_card_number: '',
		working_conditions: null,
		sheet_date: ''
	},
	isFormReadyToSubmit: false
};


export function formReducer(state, action) {
	// eslint-disable-next-line default-case
	switch (action.type) {
	case 'SET_VALUE':
		return {...state, values: {...state.values, ...action.payload}};
	case 'SET_FROM_WORKPLACE': {
		// The table row nests the references (profession/division объектами),
		// while the form works with plain ids.
		const workplace = action.payload;
		return {
			...state,
			values: {
				type: workplace.type ?? null,
				external_id: workplace.external_id ?? '',
				position: workplace.position ?? '',
				profession_id: workplace.profession?.id ?? null,
				division_id: workplace.division?.id ?? null,
				sout_card_number: workplace.sout_card_number ?? '',
				working_conditions: workplace.working_conditions ?? null,
				sheet_date: workplace.sheet_date ?? ''
			},
			isValid: INITIAL_STATE.isValid,
			isFormReadyToSubmit: false
		};
	}
	case 'CLEAR':
		return {
			...state,
			values: INITIAL_STATE.values,
			isValid: INITIAL_STATE.isValid,
			isFormReadyToSubmit: false
		};
	case 'SET_VALIDITY_FOR_FIELD':
		return {
			...state,
			isValid: {
				...state.isValid,
				[action.payload]: true
			}
		};
	case 'SUBMIT': {
		const isFilled = (value) => (
			value !== undefined &&
			value !== null &&
			value !== '' &&
			value !== 0
		);
		const typeValidity = isFilled(state.values.type);
		const externalIdValidity = String(state.values.external_id || '').trim().length > 0;
		const positionValidity = String(state.values.position || '').trim().length > 0;
		const professionValidity = isFilled(state.values.profession_id);
		const divisionValidity = isFilled(state.values.division_id);

		return {
			...state,
			isValid: {
				type: typeValidity,
				external_id: externalIdValidity,
				position: positionValidity,
				profession_id: professionValidity,
				division_id: divisionValidity
			},
			isFormReadyToSubmit: (
				typeValidity &&
				externalIdValidity &&
				positionValidity &&
				professionValidity &&
				divisionValidity
			)
		};
	}
	}
}